import { withRouter } from 'react-router-dom';
const $ = require('jquery');
import DateRangePicker from '../components/dateRange';
import DyanamicDropDown from '../components/DyanamicDropDown';
import BranchDropDown from '../components/BranchDropDown';
import BatchDropDown from '../components/BatchDropDown';
import FacultiesDropDown from '../components/FacultiesDropDown';
import GradeDropDown from '../components/GradeDropDown';
import CerReleasedDropDown from '../components/CerReleasedDropDown';
import CourseSubscriptionStatusDropDown from '../components/CourseSubscriptionStatusDropDown';
import CertificateStatusDropDown from '../components/CertificateStatusDropDown';
import ProgressCompleteDropDown from '../components/ProgressCompleteDropDown';
import ProgressDropDown from '../components/ProgressDropDown';
import WithSystem from './../service/WithSystem';
class FilterBlock extends React.Component {
  constructor(props) {
    super(props);
    hideBranch = window.hideBranch;
    this.state = { hideBranch,DyanamicDropDownState: false, BranchDropDownstate: false, BatchDropDownstate: false, GradeDropDownState: false, CerReleasedDropDownState: false, courseSubscriptionStatusDropDownState: false, FacultiesDropDownState:false, certificateStatusDropDownState: false };
  }
  enrollmentDatePickerOnApply = (event, picker) => {
    let pickerStartAndEndDate     = document.getElementById('date-range-1').value;
    pickerStartAndEndDate         = pickerStartAndEndDate.split('-');
    let startdate                 = pickerStartAndEndDate[0].trim();
    let enddate                   = pickerStartAndEndDate[1].trim();
    this.props.setGlobalState({ startdate,enddate});
  }
  completionDatePickerOnApply = (event, picker) => {
    let pickerStartAndEndDate         = document.getElementById('date-range').value;
    pickerStartAndEndDate             = pickerStartAndEndDate.split('-');
    let comstartdate                  = pickerStartAndEndDate[0].trim();
    let comenddate                    = pickerStartAndEndDate[1].trim();
    this.props.setGlobalState({ comstartdate,comenddate });
  }
  certExpiryDatePickerOnApply = (event, picker) => {
    let pickerStartAndEndDate         = document.getElementById('date-range-cert-expiry').value;
    pickerStartAndEndDate             = pickerStartAndEndDate.split('-');
    let certexpirystartdate                  = pickerStartAndEndDate[0].trim();
    let certexpiryenddate                    = pickerStartAndEndDate[1].trim();
    this.props.setGlobalState({ certexpirystartdate,certexpiryenddate });
  }
  handleCallback = (start, end, label) => {
  }
  handleChange = (startdate, enddate) => {
  };
  handleEventCompletion = (event, picker) => {
  }
  dropdownToggleCloseCall = () => {
    this.setState({ DyanamicDropDownState: false, BranchDropDownstate: false, BatchDropDownstate: false, GradeDropDownState: false, CerReleasedDropDownState: false, courseSubscriptionStatusDropDownState: false, enrollDateBlock: false, completionDateBlock: false, certificateStatusDropDownState: false, certificateExpiryDateBlock: false });
  }
  convertDateFormat = (string ,dateFormat = false) => {
    const dateOnlyFormat = window.formatAMPM(window.changeDatesFormat(string)).split(" ");
    return dateOnlyFormat[0];
}
  dateEnrollmentCallbacks = (event, picker) => {
    if (event.type == 'show') {
      this.setState({ enrollDateBlock: true });
    }
    if (event.type == 'hide') {
      this.setState({ enrollDateBlock: false });
    }
  }
  completionEnrollmentCallbacks = (event, picker) => {
    if (event.type == 'show') {
      this.setState({ completionDateBlock: true });
    }
    if (event.type == 'hide') {
      this.setState({ completionDateBlock: false });
    }
  }

  certificateExpiryDateCallbacks = (event, picker) => {
    if (event.type == 'show') {
      this.setState({ certificateExpiryDateBlock: true });
    }
    if (event.type == 'hide') {
      this.setState({ certificateExpiryDateBlock: false });
    }
  }
  render() {
    var today       = new Date();
    var dd          = String(today.getDate()).padStart(2, '0');
    var mm          = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy        = today.getFullYear();
        today       = mm + '/' + dd + '/' + yyyy;
    let datepickerintial = {
      startDate: today, endDate: today, locale: {
        format: 'MM/DD/YYYY'
      }
    };
    console.log('query filter ',this.props.queryFilter);
    if (this.props.queryFilter.startdate != false && this.props.queryFilter.enddate != false) {
      datepickerintial = {
        startDate: this.props.queryFilter.startdate, endDate: this.props.queryFilter.enddate, locale: {
          format: 'MM/DD/YYYY'
        }
      };
    }
    let datepickercompletionintial = {
      startDate: today, endDate: today, locale: {
        format: 'MM/DD/YYYY'
      }
    };
    let datepickercertificateexpiryintial = {
      startDate: today, endDate: today, locale: {
        format: 'MM/DD/YYYY'
      }
    };
    if (this.props.queryFilter.comstartdate != false && this.props.queryFilter.comenddate != false) {
      datepickercompletionintial = {
        startDate: this.props.queryFilter.comstartdate, endDate: this.props.queryFilter.comenddate, locale: {
          format: 'MM/DD/YYYY'
        }
      };
    }
    if (this.props.queryFilter.certexpirystartdate != false && this.props.queryFilter.certexpiryenddate != false) {
      datepickercertificateexpiryintial = {
        startDate: this.props.queryFilter.certexpirystartdate, endDate: this.props.queryFilter.certexpiryenddate, locale: {
          format: 'MM/DD/YYYY'
        }
      };
    }
    return (
    <div className="leaner-progress-filter-sec show">
      <div className="container-fluid">
        <div className="leaner-progress-wrap">
          <DyanamicDropDown dropdownToggle={this.state.DyanamicDropDownState} />
          {this.state.hideBranch == 'no' && <BranchDropDown dropdownToggle={this.state.BranchDropDownState} />}
          
          <BatchDropDown dropdownToggle={this.state.BatchDropDownState} />
          <FacultiesDropDown dropdownToggle={this.state.FacultiesDropDownState} />

            <div className={this.state.enrollDateBlock ? 'date-filter active' : 'date-filter'} >
            <span className="filter-subtxt">Date of Enrollment</span>
            <span className="form-control" id="date-range-1-span">{this.props.queryFilter.startdate != false?`${this.convertDateFormat(this.props.queryFilter.startdate)} - ${this.convertDateFormat(this.props.queryFilter.enddate)}`:`Select Date`}</span>
              <DateRangePicker onEvent={this.dateEnrollmentCallbacks}  onApply={this.enrollmentDatePickerOnApply}   initialSettings={datepickerintial} >
              <input type="text" name="daterange" id="date-range-1" className="form-control pull-right date-filter-span" autoComplete="off" readOnly="readonly" placeholder="Select Date" />
            </DateRangePicker>
          </div>
            <div className={this.state.completionDateBlock? 'date-filter active' : 'date-filter'} >
            <span className="filter-subtxt">Date of completion</span>
            <span className="form-control" id="date-range-span">{this.props.queryFilter.comstartdate != false?`${this.convertDateFormat(this.props.queryFilter.comstartdate)} - ${this.convertDateFormat(this.props.queryFilter.comenddate)}`:`Select Date`}</span>
              <DateRangePicker onEvent={this.completionEnrollmentCallbacks} initialSettings={datepickercompletionintial}  onApply={this.completionDatePickerOnApply} >
              <input type="text" name="daterange" id="date-range" className="form-control pull-right date-filter-span" autoComplete="off" readOnly="readonly" placeholder="Select Date"  />
            </DateRangePicker>
          </div>
          <ProgressDropDown />
          <ProgressCompleteDropDown />  
          <CerReleasedDropDown dropdownToggle={this.state.CerReleasedDropDownState} />
          <CourseSubscriptionStatusDropDown dropdownToggle={this.state.courseSubscriptionStatusDropDownState} />
          <GradeDropDown dropdownToggle={this.state.GradeDropDownState} />
          <CertificateStatusDropDown dropdownToggle={this.state.certificateStatusDropDownState} />

          <div className={this.state.certificateExpiryDateBlock? 'date-filter active' : 'date-filter'} >
            <span className="filter-subtxt">Certificate expiry date</span>
            <span className="form-control" id="date-range-cert-expiry-span">{this.props.queryFilter.certexpirystartdate != false?`${this.convertDateFormat(this.props.queryFilter.certexpirystartdate)} - ${this.convertDateFormat(this.props.queryFilter.certexpiryenddate)}`:`Select Date`}</span>
              <DateRangePicker onEvent={this.certificateExpiryDateCallbacks} initialSettings={datepickercertificateexpiryintial}  onApply={this.certExpiryDatePickerOnApply} >
              <input type="text" name="certdaterange" id="date-range-cert-expiry" className="form-control pull-right date-filter-span" autoComplete="off" readOnly="readonly" placeholder="Select Date"  />
            </DateRangePicker>
          </div>
            {/*<div className="branch-list">
            <span className="filter-subtxt">Score</span>
            <div className="dropdown bc-column-selector">
              <div className="branch-list-sec" data-toggle="dropdown" aria-expanded="false">Score</div>
              <ul className="dropdown-menu">
                  <li><label><input className="bc_column_visible bc_initial_events" data-column={3} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" value id="bc_column_3" /> <span className="checkedmark"></span> EV152 - Safe Pass</label></li>
                  <li><label><input className="bc_column_visible bc_initial_events" data-column={4} data-column-name="Submitted" type="checkbox" data-field-name="submittedon" value id="bc_column_4" /> <span className="checkedmark"></span> EV152 - Safe Pass</label></li>
                  <li><label><input className="bc_column_visible bc_initial_events" data-column={5} data-column-name="Paid" type="checkbox" data-field-name="paid" value id="bc_column_5" /> <span className="checkedmark"></span> EV152 - Safe Pass</label></li>
                  <li><label><input className="bc_column_visible bc_initial_events" data-column={6} data-column-name="Due" type="checkbox" data-field-name="due" value id="bc_column_6" /> <span className="checkedmark"></span> EV152 - Safe Pass</label></li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
    )
  }
}
export default WithSystem(FilterBlock);